export const setGoogleAgendaLinked = payload =>({
    type: 'ISLINKED',
    payload: payload,
})